import { ComponentFactoryResolver, ComponentRef, ViewContainerRef } from '@angular/core';
import { Observable } from 'rxjs';
import { CoreCardReviewRendererType, CoreCustomCardType } from '../../../class/workflow.type';
import { workflowCardRegistry } from '../../shared/workflow-registries';
import { CardElementsBaseComponent } from '../shared/card-elements-base.component';
import { PageInstance } from '@workflow/class/page.service';
import { CardInstance } from '@workflow/class/card.service';

export class CardResolveHelper {
  constructor(
    private readonly componentFactoryResolver: ComponentFactoryResolver,
    private readonly cardContainer: ViewContainerRef,
    private readonly page: PageInstance,
    private readonly card: CardInstance,
    private readonly cardIndex: number,
    private readonly pageSubmitted$: Observable<boolean>
  ) {}

  public resolve(type: CoreCustomCardType | CoreCardReviewRendererType): ComponentRef<CardElementsBaseComponent> {
    const cardInstance = workflowCardRegistry[type];
    if (!cardInstance) {
      throw new Error(`No Card has been registered for type '${type}' in card id '${this.card.id}'. `);
    }

    const factory = this.componentFactoryResolver.resolveComponentFactory(workflowCardRegistry[type]);
    const componentRef = this.cardContainer.createComponent(factory) as ComponentRef<CardElementsBaseComponent>;
    componentRef.instance.page = this.page;
    componentRef.instance.card = this.card;
    componentRef.instance.cardIndex = this.cardIndex;
    componentRef.instance.pageSubmitted$ = this.pageSubmitted$;

    return componentRef;
  }
}
